import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { FaMapMarkerAlt } from 'react-icons/fa';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './locationCompany.scss';

const createTransparentIcon = () => {
  return new L.Icon({
    iconUrl:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="%23FFC310"><path d="M16 2C9.37 2 4 7.37 4 14c0 10.5 12 16 12 16s12-5.5 12-16c0-6.63-5.37-12-12-12z"/></svg>',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    className: 'transparent-marker-icon',
  });
};

const locations = [
  {
    name: 'Madrid',
    coords: [40.41956, -3.69196],
  },
  {
    name: 'Extremadura',
    coords: [38.9207, -6.3428],
  },
];

const LocationCompany = () => {
  return (
    <div className="locationCompany">
      <div className="locationCompany__container">
        <div className="locationCompany__locations-list">
          <div className="locationCompany__item">
            <div className="locationCompany__icon-wrapper">
              <FaMapMarkerAlt className="locationCompany__icon" />
            </div>
            <div className="locationCompany__text">
              <h3 className="locationCompany__title">Dónde estamos</h3>
              <h3 className="locationCompany__subtitle">
                Madrid y Extremadura
              </h3>
            </div>
          </div>
          <div className="locationCompany__item">
            <div className="locationCompany__icon-wrapper">
              <FaMapMarkerAlt className="locationCompany__icon" />
            </div>
            <div className="locationCompany__text">
              <h3 className="locationCompany__title">Contacto directo</h3>
              <h3 className="locationCompany__subtitle">
                arodriguez@wonderaly.com
              </h3>
            </div>
          </div>
        </div>

        <div className="locationCompany__map-container">
          <MapContainer
            center={[39.8, -4.5]}
            zoom={6}
            scrollWheelZoom={false}
            className="locationCompany__map"
          >
            <TileLayer
              url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
              opacity={1}
            />
            {locations.map((loc) => (
              <Marker
                key={loc.name}
                position={loc.coords}
                icon={createTransparentIcon()}
              />
            ))}
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default LocationCompany;
